import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, isRef as _isRef, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "col" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "verified-email" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = {
  id: "login-password",
  for: "password"
}
const _hoisted_6 = { class: "input-group has-validation" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", {
  class: "input-group-text",
  id: "inputGroupPrepend"
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "currentColor",
    class: "bi bi-key",
    viewBox: "0 0 16 16"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M0 8a4 4 0 0 1 7.465-2H14a.5.5 0 0 1 .354.146l1.5 1.5a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0L13 9.207l-.646.647a.5.5 0 0 1-.708 0L11 9.207l-.646.647a.5.5 0 0 1-.708 0L9 9.207l-.646.647A.5.5 0 0 1 8 10h-.535A4 4 0 0 1 0 8m4-3a3 3 0 1 0 2.712 4.285A.5.5 0 0 1 7.163 9h.63l.853-.854a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .708 0l.646.647.793-.793-1-1h-6.63a.5.5 0 0 1-.451-.285A3 3 0 0 0 4 5" }),
    /*#__PURE__*/_createElementVNode("path", { d: "M4 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0" })
  ])
], -1)
const _hoisted_8 = { class: "row mt-2" }
const _hoisted_9 = ["aria-label"]
const _hoisted_10 = { class: "row mt-3" }

import {computed} from 'vue';
    import {useForm, useField, Form, Field} from 'vee-validate';
    import {object, string} from 'yup';
    import {Login} from '@/models/login.model';
    import {getErrorMessages} from '@/services/utils/a11y-form-announce.service';
    import {getStoredEmail} from '@/services/session/account-store.service';

    
export default /*#__PURE__*/_defineComponent({
  name: 'LoginForm',
  emits: ["authenticate"],
  setup(__props, { emit }: { emit: ({
        (e: 'authenticate', email: Login): void;
    }), expose: any, slots: any, attrs: any }) {

    

    const storedEmail = computed(() => {
        return getStoredEmail();
    });

    const {errors, handleSubmit} = useForm({
        initialValues: {
            email: storedEmail.value ?? '',
            password: '',
        },
        validationSchema: object({
            email: string().email().required(),
            password: string().min(6).required(),
        }),
    });

    const {value: email} = useField('email');
    const {value: password} = useField('password');

    const submit = handleSubmit((values) => {
        emit('authenticate', values as Login);
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Form), {
    onSubmit: _unref(submit),
    class: "row g-3"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(storedEmail)), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.$t('login.form.password')), 1),
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode(_unref(Field), {
              id: "password",
              name: "password",
              type: "password",
              modelValue: _unref(password),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(password) ? (password).value = $event : null)),
              "aria-labelledby": "login-password",
              "aria-label": _ctx.$t('login.form.password'),
              "aria-required": "true",
              class: "form-control",
              required: ""
            }, null, 8, ["modelValue", "aria-label"])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          (_unref(errors).password)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: "form-field-error-message",
                "aria-label": _ctx.$t('login.form.error.password')
              }, _toDisplayString(_ctx.$t('login.form.error.password')), 9, _hoisted_9))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("button", {
            type: "submit",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(getErrorMessages) && _unref(getErrorMessages)(...args))),
            class: "btn btn-primary button-primary"
          }, _toDisplayString(_ctx.$t('login.form.submit')), 1)
        ])
      ])
    ]),
    _: 1
  }, 8, ["onSubmit"]))
}
}

})